import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import { setPage, setLimit } from "../../store/slices/directBossSlice.ts";

const PaginationDirectBoss = () => {
  const dispatch = useDispatch();
  const { page, limit, directBosses, total } = useSelector(
    (state: RootState) => state.directBoss
  );

  const handleLimitChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = parseInt(event.target.value);
    dispatch(setLimit(newLimit));
    dispatch(setPage(0));
  };

  // Verificar que directBosses existe y tiene datos
  if (!directBosses || directBosses.length === 0) {
    return null; // No mostrar paginación si no hay datos
  }

  const startRecord = page * limit + 1;
  const endRecord = page * limit + directBosses.length;

  const totalPages = Math.ceil(total / limit);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      const startPage = Math.max(0, page - Math.floor(maxVisiblePages / 2));
      const endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  return (
    <div
      className="d-md-flex align-items-center justify-content-between"
      style={{
        padding: "12px 16px",
        backgroundColor: "#f8fafc",
        borderRadius: 12,
        border: "1px solid #e2e8f0",
      }}
    >
      <div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
        <div className="d-flex align-items-center">
          <span className="me-2">
            Mostrando {startRecord} - {endRecord} de {total} jefes directos
          </span>
        </div>
      </div>

      <div className="d-flex align-items-center">
        <span className="me-2">Mostrar:</span>
        <select
          className="form-select me-3"
          value={limit}
          onChange={handleLimitChange}
          style={{ width: "auto" }}
        >
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <ul className="pagination mb-0">
          <li className={`page-item ${page === 0 && "disabled"}`}>
            <button
              className="page-link"
              onClick={() => page > 0 && dispatch(setPage(page - 1))}
              disabled={page === 0}
            >
              <i className="fa fa-chevron-left"></i>
              Anterior
            </button>
          </li>

          <li className={`page-item ${endRecord >= total && "disabled"}`}>
            <button
              className="page-link"
              onClick={() => endRecord < total && dispatch(setPage(page + 1))}
              disabled={endRecord >= total}
            >
              Siguiente
              <i className="fa fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PaginationDirectBoss;
